import React, { useState, useEffect, useRef } from "react";
import "../component.css";
import {
    Grid,
    Typography,
    Paper,
    Button,
    Tabs,
    Tab,
    Box,
    Fab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    InputBase,
    InputLabel,
    IconButton,
    MenuItem,
    TextField,
    NativeSelect,
    TableFooter,
    TablePagination,
    TablePaginationActions,
    Select,
    // Pagination,
    Card,
    CardContent,
    Radio,
} from "@mui/material";
import Pagination from 'react-js-pagination';

import { alpha, styled } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import PropTypes from "prop-types";

import ArrowLeft from "@mui/icons-material/ArrowBack";
import Chart from "react-apexcharts";
import {
    Square,
    Close,
    Warning,
    Print,
    Pages,
    CheckCircle,
    History,
} from "@mui/icons-material";

import config from "config";
import LibraryApiCall from "LibraryApiCall";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { useReactToPrint } from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import RoutingMenu from "LIBRARY/CommonResources/RoutingMenu/RoutingMenu";

export default function ScannedResources(props) {
    const [scannedResourcesList, setScannedResourcesList] = useState([]);
    const [totalScannedResources, setTotalScannedResources] = useState(0);

    const [scannedResourcesData, setScannedResourcesData] = useState({
        TotalResource: 44789,
        VerifiedResource: 30000,
        NewlyFoundResource: 3500,
        IssuedResource: 6500,
        MissingResource: 4789,
    });

    const [markAsCompletedData, setMarkAsCompletedData] = useState({});
    const [scannedResourcesFilters, setScannedResourcesFilters] = useState({
        accessionsSeries: "",
        scanned_by: "",
        verificationStatus: "",
        fromDate: "",
        toDate: "",
    });

    const [selectedFaculty, setSelectedFaculty] = useState({});
    const [facultyList, setFacultyList] = useState([]);

    const [isFilterApply, setIsFilterApply] = useState(false);

    const [pagination, setPagination] = useState({
        pageIndex: 1,
        pagePerlimit: 10,
    });

    const [IssuedResourcePagination, setIssuedResourcePagination] = useState({
        pageIndex: 1,
        limit: 10,
    });

    const [IssuedResources, setIssuedResources] = useState({});
    const [IssuedResourcesSortedIdArray, setIssuedResourcesSortedIdArray] =
        useState([]);
    const [totalIssuedResourceCount, setTotalIssuesResourceCount] = useState(0);

    const [missingResourceList, setMissingResourceList] = useState([]);
    const [totalMissingCount, setTotalMissingCount] = useState(0);
    const [missingResourcePagination, setMissingResourcePagination] = useState({
        pageIndex: 1,
        limit: 10,
    });

    const [confirmationModal, setConfirmationModal] = useState(false);
    const [scannedByModal, setScannedByModal] = useState(false);
    const [totalScannedBy, setTotalScannedBy] = useState(0);
    const [paginationScannedBy, setPaginationScannedBy] = useState({
        pageIndex: 1,
        limit: 20,
    });

    const [searchByScannnedName, setSearchByScannedName] = useState("");
    
    //barcode/manual entry
    const [barcodeManualNumber, setBarcodeManualNumber] = useState("");
    const [accessionSeriesValue, setAccessionSeriesValue] = useState("");
    const [accessionSeriesList, setAccessionSeriesList] = useState({});

    // Untitiled states
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue == 1) {
            apiCallToIssuedResourceList();
        } else if (newValue == 2) {
            apiCallToMissingResourceList();
        }
    };

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const { enqueueSnackbar } = useSnackbar();

    React.useEffect(() => {
        apiCallToGetStockVerificationCount();
        apiCallToGetScannedResourceList();
        // apiCallToIssuedResourceList();
        // apiCallToMissingResourceList();
        apiCallToGetFacultyList();
        apiCallToGetAccessionSeries();
    }, []);

    useEffect(() => {
        apiCallToGetScannedResourceList();
    }, [pagination]);

    useEffect(() => {
        apiCallToIssuedResourceList();
    }, [IssuedResourcePagination]);

    useEffect(() => {
        apiCallToMissingResourceList();
    }, [missingResourcePagination]);

    useEffect(() => {
        apiCallToGetFacultyList();
    }, [paginationScannedBy]);

    useEffect(() => {
        if (isFilterApply) {
            apiCallToGetScannedResourceList();
            setIsFilterApply(false);
        }
    }, [isFilterApply]);

    // API CALL TO ISSUES RESOURCE LIST
    const apiCallToGetStockVerificationCount = async () => {
        let requestData = {
            iid: config.institute_id,
            stock_verification_id: props.selectedStockVerification.uniqueId,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "getStockVerificationCount",
            requestData,
            "/api/library/stockVerification.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetStockVerificationCount();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (Object.values(jsonResponse.APIResult.data).length > 0) {
                    setScannedResourcesData({
                        TotalResource: Object.values(
                            jsonResponse.APIResult.data
                        )[0].TotalResource,
                        VerifiedResource: Object.values(
                            jsonResponse.APIResult.data
                        )[0].VerifiedResource,
                        NewlyFoundResource: Object.values(
                            jsonResponse.APIResult.data
                        )[0].NewlyFoundResource,
                        IssuedResource: Object.values(
                            jsonResponse.APIResult.data
                        )[0].IssuedResource,
                        MissingResource: Object.values(
                            jsonResponse.APIResult.data
                        )[0].MissingResource,
                    });
                    setMarkAsCompletedData(
                        jsonResponse.APIResult.markAsCompleted
                    );
                } else {
                }
            } else {
            }
        }
    };

    // API CALL TO GET SCANNED RESOURCE LIST
    const apiCallToGetScannedResourceList = async () => {
        let requestData = {
            iid: config.institute_id,
            uniqueId: props.selectedStockVerification.uniqueId,
            pageIndex: `${pagination.pageIndex}`,
            limitPerPage: `${pagination.pagePerlimit}`,
            filterData: scannedResourcesFilters,
        };


        let jsonResponse = await LibraryApiCall.makeApiCall(
            "getStockVerificationScannedResourceList",
            requestData,
            "/api/library/stockVerification.php"
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetScannedResourceList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status != "fail") {
                    setScannedResourcesList(
                        Object.values(jsonResponse.APIResult.data)
                    );
                    setScannedResourcesData(
                        jsonResponse.APIResult.stockVerificationCount
                    );
                    setTotalScannedResources(jsonResponse.APIResult.totalCount);
                    // if (this.state.scannedResourceList.length == 0) {
                    //     this.setState({
                    //         scannedResourceList: Object.values(jsonResponse.APIResult.data),
                    //         scannedResourcesData: jsonResponse.APIResult.stockVerificationCount,
                    //         totalCount: jsonResponse.APIResult.stockVerificationCount.TotalResource,
                    //         loadingScannedResouceList: false,
                    //         loadMoreScannedResourceList: false,
                    //         userRefresh: false
                    //     })
                    // } else {
                    //     this.setState({
                    //         scannedResourceList: this.state.scannedResourceList.concat(Object.values(jsonResponse.APIResult.data)),
                    //         scannedResourcesData: jsonResponse.APIResult.stockVerificationCount,
                    //         totalCount: jsonResponse.APIResult.stockVerificationCount.TotalResource,
                    //         loadingScannedResouceList: false,
                    //         loadMoreScannedResourceList: false,
                    //         userRefresh: false
                    //     })
                    // }
                } else {
                }
            } else {
            }
        }
    };

    // API CALL TO MARK AS COMPLETED
    const apiCallToMarkAsCompleted = async () => {
        let requestData = {
            iid: config.institute_id,
            facultyId: config.faculty_id,
            library_resource_stock_verification_id:
                props.selectedStockVerification.uniqueId,
        };


        let jsonResponse = await LibraryApiCall.makeApiCall(
            "changeStockVerificationCompletedStatus",
            requestData,
            "/api/library/stockVerification.php"
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetScannedResourceList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status != "fail") {
                    setConfirmationModal(false);
                    apiCallToGetStockVerificationCount();
                    enqueueSnackbar(jsonResponse.APIResult.message, {
                        variant: "success",
                    });
                } else {
                    enqueueSnackbar(jsonResponse.APIResult.message, {
                        variant: "error",
                    });
                }
            } else {
                enqueueSnackbar(jsonResponse.APIResult.message, {
                    variant: "error",
                });
            }
        }
    };

    // API CALL TO MARK AS IN PROGRESS
    const apiCallToMarkAsProgress = async () => {
        let requestData = {
            iid: config.institute_id,
            facultyId: config.faculty_id,
            stock_verification_id: props.selectedStockVerification.uniqueId,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "stockVerificationMarkAsInProcess",
            requestData,
            "/api/library/stockVerification.php"
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToMarkAsProgress();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status != "fail") {
                    apiCallToGetStockVerificationCount();
                    enqueueSnackbar(jsonResponse.APIResult.message, {
                        variant: "success",
                    });
                } else {
                    enqueueSnackbar(jsonResponse.APIResult.message, {
                        variant: "error",
                    });
                }
            } else {
                enqueueSnackbar(jsonResponse.APIResult.message, {
                    variant: "error",
                });
            }
        }
    };

    // API CALL TO ISSUES RESOURCE LIST
    const apiCallToIssuedResourceList = async () => {
        let requestData = {
            iid: config.institute_id,
            pageIndex: IssuedResourcePagination.pageIndex,
            limitPerPage: IssuedResourcePagination.limit,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "getStockVerificationIssuedResourceList",
            requestData,
            "/api/library/stockVerification.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToIssuedResourceList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (Object.values(jsonResponse.APIResult.data).length > 0) {
                    setIssuedResources(jsonResponse.APIResult.data);
                    setIssuedResourcesSortedIdArray(
                        jsonResponse.APIResult.sortedIdArray
                    );
                    setTotalIssuesResourceCount(
                        jsonResponse.APIResult.totalRecords
                    );
                } else {
                    setIssuedResources({});
                    setIssuedResourcesSortedIdArray([]);
                    setTotalIssuesResourceCount(0);
                }
            } else {
            }
        }
    };

    // API CALL TO MISSING RESOURCE LIST
    const apiCallToMissingResourceList = async () => {
        let requestData = {
            iid: config.institute_id,
            stock_verification_id: props.selectedStockVerification.uniqueId,
            pageIndex: missingResourcePagination.pageIndex,
            limitPerPage: missingResourcePagination.limit,
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            "getStockVerificationMissingResourceList",
            requestData,
            "/api/library/stockVerification.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToMissingResourceList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (Object.values(jsonResponse.APIResult.data).length > 0) {
                    setMissingResourceList(
                        Object.values(jsonResponse.APIResult.data)
                    );
                    setTotalMissingCount(jsonResponse.APIResult.totalCount);
                } else {
                    setMissingResourceList([]);
                    setTotalMissingCount(0);
                }
            } else {
            }
        }
    };

    // API CALL TO
    const apiCallToGetFacultyList = async () => {
        let requestData = {
            iid: config.institute_id,
            type: "all",
            page_index: paginationScannedBy.pageIndex,
            limit: paginationScannedBy.limit,
            search: searchByScannnedName,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "getFacultyList",
            requestData,
            "/api/instructor/facultyRegistration.php"
        );


        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetFacultyList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (Object.values(jsonResponse.APIResult.data).length > 0) {
                    setFacultyList(jsonResponse.APIResult.data);
                    setTotalScannedBy(jsonResponse.APIResult.totalRecords);
                } else {
                    setFacultyList([]);
                }
            } else {
                setFacultyList([]);
            }
        }
    };

    const handleChangePage = (event) => {

        setPagination({
            pageIndex: 1,
            pagePerlimit: event.target.value,
        });
    };

    const handleChangeRowsPerPage = (page) => {
        // setRowsPerPage(event.target.value);
        setPage(0);
        setPagination({
            pageIndex: page,
            pagePerlimit: pagination.pagePerlimit,
        });
    };

    const handleChangeForMissingResourcePage = (event) => {
        setMissingResourcePagination({
            // pageIndex: newPage + 1,
            pageIndex: 1,
            limit: event.target.value,
        });
    };

    const handleChangeForMissingResourceRowsPerPage = (page) => {
        setMissingResourcePagination({
            pageIndex: page,
            limit: missingResourcePagination.limit,
        });
    };

    const handleChangeForIssuedResourcePage = (event) => {
        setIssuedResourcePagination({
            // pageIndex: newPage + 1,
            pageIndex: 1,
            limit: event.target.value,
        });
    };

    const handleChangeForIssuedResourceRowsPerPage = (page) => {
        setIssuedResourcePagination({
            pageIndex: page,
            limit: IssuedResourcePagination.limit,
        });
    };

    const handleChangeForHandleScannedByPage = (event, newPage) => {
        setPaginationScannedBy({
            pageIndex: newPage + 1,
            limit: paginationScannedBy.limit,
        });
    };

    const handleChangeForScannedByRowsPerPage = (event) => {
        setPaginationScannedBy({
            pageIndex: 1,
            limit: event.target.value,
        });
    };

    // APPLY FILTER TO SCANNED RESOURCE LIST
    const applyFilters = () => {
        setPagination({
            pageIndex: 1,
            pagePerlimit: 10,
        });
        setIsFilterApply(true);
    };

    // CLEAR FILTERS TO SCANNED RESOURCE LIST
    const clearFilters = () => {
        setScannedResourcesFilters({
            accessionsSeries: "",
            scanned_by: "",
            verificationStatus: "",
            fromDate: "",
            toDate: "",
        });
        setSelectedFaculty({});
        setIsFilterApply(true);
    };

    // HANDLE PRINT
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    //API CALL METHOD TO GET ACCESSION SERIES
    const apiCallToGetAccessionSeries = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId,
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                setAccessionSeriesList(formattedMembers)
               
            } else {
                 enqueueSnackbar("Something went wrong while getting accession series list. Please try again later.", {
                    variant: "error",
                });
            }
        }
    }

    // API CALL TO GET SCANNED RESOURCE LIST
    const apiCallToScanManualResource = async () => {
        let requestData = {
            iid: config.institute_id,
            facultyId: config.faculty_id,
            library_resource_stock_verification_id:
                props.selectedStockVerification.uniqueId,
            barcode_text: barcodeManualNumber,
            selectedAccessionsKey: accessionSeriesValue || ''
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "addScannedResourceInStockVerification",
            requestData,
            "/api/library/stockVerification.php"
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToScanManualResource();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status != "fail") {
                    setConfirmationModal(false);
                    apiCallToGetScannedResourceList();
                    enqueueSnackbar(jsonResponse.APIResult.message, {
                        variant: "success",
                    });
                    setBarcodeManualNumber("")
                    // setAccessionSeriesValue("")
                } else {
                    enqueueSnackbar(jsonResponse.APIResult.message, {
                        variant: "error",
                    });
                }
            } else {
                enqueueSnackbar(jsonResponse.APIResult.message, {
                    variant: "error",
                });
            }
        }
    };

    // scan manual barcode number
    const scanManualBarcode = () => {
      apiCallToScanManualResource();
    };

    return (
        <>
            <RoutingMenu activeScreen="stockVerification" />
            <div className="libraryStock-container">
                <Grid container sx={{ padding: "3rem 1rem", background: "#F3F3F3" }}>
                    <Box
                        mt={3}
                        mb={2}
                        sx={{
                            display: "flex",
                            "align-items": "center",
                            gap: "10px",
                        }}>
                        <Fab
                            className="backButton"
                            color='white'
                            size={"small"}
                            sx={{ background: "#FFF" }}
                            aria-label='back'
                            onClick={() => props.closeScannedResources()}>
                            <ArrowLeft />
                        </Fab>
                        <Typography variant='h6' sx={{ fontSize: 18 }}>
                            {
                                props.selectedStockVerification
                                    .stock_verification_name
                            }
                        </Typography>
                    </Box>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item lg={8} md={12} sm={12} xs={12}>
                                <Grid
                                    container
                                    component={Paper}
                                    elevation={0}
                                    sx={{ p: 5 }}>
                                    <Grid lg={4} md={4} sm={4}>
                                        <Chart
                                            options={{
                                                legend: {
                                                    show: false,
                                                },
                                                labels: [
                                                    "Total Resource",
                                                    "Verified Resource",
                                                    "Newly Found Resource",
                                                    "Issued Resource",
                                                    "Missing Resource",
                                                ],
                                                fill: {
                                                    colors: [
                                                        "#3281EB",
                                                        "#5DC188",
                                                        "#BA6EE1",
                                                        "#5ECDF2",
                                                        "#787885",
                                                    ],
                                                },
                                                dataLabels: {
                                                    style: {
                                                        colors: [
                                                            "#3281EB",
                                                            "#5DC188",
                                                            "#BA6EE1",
                                                            "#5ECDF2",
                                                            "#787885",
                                                        ],
                                                    },
                                                    enabled: false,
                                                },
                                            }}
                                            series={[
                                                scannedResourcesData.TotalResource,
                                                scannedResourcesData.VerifiedResource,
                                                scannedResourcesData.NewlyFoundResource,
                                                scannedResourcesData.IssuedResource,
                                                scannedResourcesData.MissingResource,
                                            ]}
                                            type='donut'
                                            width='280'
                                        />
                                    </Grid>

                                    <Grid lg={8} md={8} sm={8}>
                                        <Stack spacing={1}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                }}
                                            >
                                                <Square sx={{ color: "#3281EB", mx: 3 }} />

                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                                                        {scannedResourcesData.TotalResource} - Total Resources
                                                    </Typography>
                                                    <Typography component="span" sx={{ fontSize: 14 }}>
                                                        Total is the count of all resources that are present in the library.
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                }}
                                            >
                                                <Square sx={{ color: "#3281EB", mx: 3 }} />

                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                                                        {scannedResourcesData.VerifiedResource} - Verified Resources
                                                    </Typography>
                                                    <Typography component="span" sx={{ fontSize: 14 }}>
                                                        Verified is the count of resources that have been successfully scanned.
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                }}
                                            >
                                                <Square sx={{ color: "#3281EB", mx: 3 }} />

                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                                                        {scannedResourcesData.NewlyFoundResource} - Newly Found Resources
                                                    </Typography>
                                                    <Typography component="span" sx={{ fontSize: 14 }}>
                                                        Newly Found is the count of resources that were not present in the software but have now been newly discovered.
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                }}
                                            >
                                                <Square sx={{ color: "#3281EB", mx: 3 }} />

                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                                                        {scannedResourcesData.IssuedResource} - Issued Resources
                                                    </Typography>
                                                    <Typography component="span" sx={{ fontSize: 14 }}>
                                                        Issued is the count of resources that have been issued to a user but have not yet been scanned.
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                }}
                                            >
                                                <Square sx={{ color: "#3281EB", mx: 3 }} />

                                                <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                                                        {scannedResourcesData.MissingResource} - Missing Resources / Yet to Scan:
                                                    </Typography>
                                                    <Typography component="span" sx={{ fontSize: 14 }}>
                                                        Missing / Yet to Scan is the count of resources that are yet to be scanned or may be missing.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item lg={4} md={12} xs={12}>
                                <Grid container spacing={2} direction="column">

                                    {/* Barcode / Manual Entry (top) */}
                                    <Grid item>
                                        <Paper elevation={0} sx={{
                                            p: 3,
                                            minHeight: "170px" // ⬅️ added height
                                        }}>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                                Barcode / Manual Entry
                                            </Typography>

                                            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                                                {/* Accession Series */}
                                                <FormControl
                                                    variant="standard"
                                                    sx={{ flex: 1 }}
                                                    fullWidth
                                                >
                                                    <InputLabel
                                                        shrink
                                                        htmlFor="bootstrap-input"
                                                        sx={{ fontSize: 14 }}
                                                    >
                                                        Accession Series
                                                    </InputLabel>
                                                    <Select
                                                        labelId="demo-customized-select-label"
                                                        id="demo-customized-select"
                                                        sx={{ fontSize: 14 }}
                                                        value={accessionSeriesValue}
                                                        onChange={(e) => {
                                                            setAccessionSeriesValue(e.target.value);
                                                        }}
                                                        input={<BootstrapInputForSelect />}
                                                        MenuProps={{
                                                            disablePortal: true, // ensures dropdown attaches to parent instead of body
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 350,
                                                                    overflowY: "auto",
                                                                },
                                                            },
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left",
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left",
                                                            },
                                                        }}
                                                    >
                                                        {Object.values(accessionSeriesList)?.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>
                                                                {item.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>

                                                {/* Number */}
                                                <FormControl
                                                    variant="standard"
                                                    sx={{ flex: 1 }}
                                                    fullWidth
                                                >
                                                    <InputLabel
                                                        shrink
                                                        htmlFor="bootstrap-input"
                                                        sx={{ fontSize: 14 }}
                                                    >
                                                        Number
                                                    </InputLabel>
                                                    <BootstrapInput
                                                        type="text"
                                                        sx={{ fontSize: 14 }}
                                                        placeholder="Enter Number"
                                                        id="bootstrap-input"
                                                        value={barcodeManualNumber}
                                                        onChange={(e) => {
                                                            setBarcodeManualNumber(e.target.value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                if (accessionSeriesValue && barcodeManualNumber) {
                                                                    scanManualBarcode();
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </FormControl>

                                                {/* <Button
                                                    variant="contained"
                                                    onClick={() => scanManualBarcode()}
                                                >
                                                    Scan
                                                </Button> */}
                                            </Box>

                                            <Typography sx={{ fontSize: 12, color: "text.secondary", mt: 1 }}>
                                                (In case of scanning failure, please enter the code manually)
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                    {/* Stock Verification (bottom) */}
                                    <Grid item>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                padding: "3em",
                                                display: "flex",
                                                flexDirection: "column",
                                                "justify-content": "center",
                                                "align-items": "center",
                                                "flex-grow": 1,
                                                height: "100%",
                                            }}>
                                            {Object.keys(markAsCompletedData).length > 0 ? (
                                                <Box
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 10,
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            "justify-content":
                                                                "space-between",
                                                            gap: "100px",
                                                        }}>
                                                        <Box style={{ display: "flex" }}>
                                                            <CheckCircle
                                                                sx={{ color: "#43A047" }}
                                                            />
                                                            <Typography
                                                                sx={{
                                                                    color: "#43A047",
                                                                    fontSize: 16,
                                                                }}>
                                                                {markAsCompletedData.status}
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: 14 }}>
                                                                by{" "}
                                                                {
                                                                    markAsCompletedData.completedByName
                                                                }
                                                            </Typography>
                                                            <Typography sx={{ fontSize: 14 }}>
                                                                {
                                                                    markAsCompletedData.completedDate
                                                                }
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box>
                                                        <Button
                                                            variant={"outlined"}
                                                            sx={{ fontSize: 14 }}
                                                            startIcon={<History />}
                                                            onClick={() =>
                                                                apiCallToMarkAsProgress()
                                                            }>
                                                            Mark as In-Progress
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            ) : (
                                                <>
                                                    <Typography
                                                        variant={"h6"}
                                                        sx={{ fontSize: 16 }}>
                                                        {scannedResourcesData.VerifiedResource +
                                                            scannedResourcesData.NewlyFoundResource}{" "}
                                                        Resources
                                                    </Typography>
                                                    <Button
                                                        variant={"contained"}
                                                        sx={{ fontSize: 14 }}
                                                        onClick={() =>
                                                            setConfirmationModal(true)
                                                        }>
                                                        Mark as Completed
                                                    </Button>
                                                </>
                                            )}
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* <Grid item lg={4} md={12} xs={12} flexGrow={1}>
                                <Paper
                                    elevation={0}
                                    sx={{
                                        padding: "3em",
                                        display: "flex",
                                        flexDirection: "column",
                                        "justify-content": "center",
                                        "align-items": "center",
                                        "flex-grow": 1,
                                        height: "100%",
                                    }}>
                                    {Object.keys(markAsCompletedData).length > 0 ? (
                                        <Box
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10,
                                            }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    "justify-content":
                                                        "space-between",
                                                    gap: "100px",
                                                }}>
                                                <Box style={{ display: "flex" }}>
                                                    <CheckCircle
                                                        sx={{ color: "#43A047" }}
                                                    />
                                                    <Typography
                                                        sx={{
                                                            color: "#43A047",
                                                            fontSize: 16,
                                                        }}>
                                                        {markAsCompletedData.status}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Typography sx={{ fontSize: 14 }}>
                                                        by{" "}
                                                        {
                                                            markAsCompletedData.completedByName
                                                        }
                                                    </Typography>
                                                    <Typography sx={{ fontSize: 14 }}>
                                                        {
                                                            markAsCompletedData.completedDate
                                                        }
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box>
                                                <Button
                                                    variant={"outlined"}
                                                    sx={{ fontSize: 14 }}
                                                    startIcon={<History />}
                                                    onClick={() =>
                                                        apiCallToMarkAsProgress()
                                                    }>
                                                    Mark as In-Progress
                                                </Button>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <>
                                            <Typography
                                                variant={"h6"}
                                                sx={{ fontSize: 16 }}>
                                                {scannedResourcesData.VerifiedResource +
                                                    scannedResourcesData.NewlyFoundResource}{" "}
                                                Resources
                                            </Typography>
                                            <Button
                                                variant={"contained"}
                                                sx={{ fontSize: 14 }}
                                                onClick={() =>
                                                    setConfirmationModal(true)
                                                }>
                                                Mark as Completed
                                            </Button>
                                        </>
                                    )}
                                </Paper>
                            </Grid> */}
                        </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Box mt={1} sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label='disabled tabs example'>
                                <Tab
                                    {...a11yProps(0)}
                                    label='Scanned Resources'
                                    sx={{ textTransform: "capitalize", fontSize: 16 }}
                                />
                                <Tab
                                    {...a11yProps(1)}
                                    label='Issued Resources'
                                    sx={{ textTransform: "capitalize", fontSize: 16 }}
                                />
                                <Tab
                                    {...a11yProps(2)}
                                    label='Missing/Yet to Scan Resources'
                                    sx={{ textTransform: "capitalize", fontSize: 16 }}
                                />
                            </Tabs>
                        </Box>

                        <TabPanel value={value} index={0}>
                            <Grid
                                container
                                component={Paper}
                                rowGap={5}
                                columnGap={2}
                                sx={{ px: 5, pt: 3, pb: 3 }}
                                elevation={0}
                                mt={2}
                                mb={2}
                                direction={{
                                    lg: "row",
                                    md: "column",
                                    sm: "column",
                                    xs: "column",
                                }}>
                                <Grid>
                                    <FormControl
                                        variant='standard'
                                        style={{ minWidth: 230, maxWidth: "100%" }}
                                        fullWidth>
                                        <InputLabel
                                            shrink
                                            htmlFor='bootstrap-input'
                                            sx={{ fontSize: 14 }}>
                                            From Date
                                        </InputLabel>
                                        <BootstrapInput
                                            type={"date"}
                                            id='bootstrap-input'
                                            sx={{ fontSize: 14 }}
                                            value={scannedResourcesFilters.fromDate}
                                            onChange={(e) => {
                                                setScannedResourcesFilters({
                                                    ...scannedResourcesFilters,
                                                    fromDate: e.target.value,
                                                });
                                                setIsFilterApply(false);
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid>
                                    <FormControl
                                        variant='standard'
                                        style={{ minWidth: 230, maxWidth: "100%" }}
                                        fullWidth>
                                        <InputLabel
                                            shrink
                                            htmlFor='bootstrap-input'
                                            sx={{ fontSize: 14 }}>
                                            To Date
                                        </InputLabel>
                                        <BootstrapInput
                                            type={"date"}
                                            id='bootstrap-input'
                                            sx={{ fontSize: 14 }}
                                            value={scannedResourcesFilters.toDate}
                                            onChange={(e) => {
                                                setScannedResourcesFilters({
                                                    ...scannedResourcesFilters,
                                                    toDate: e.target.value,
                                                });
                                                setIsFilterApply(false);
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid>
                                    <FormControl
                                        variant='standard'
                                        style={{ minWidth: 240, maxWidth: "100%" }}
                                        fullWidth>
                                        <InputLabel
                                            shrink
                                            htmlFor='bootstrap-input'
                                            sx={{ fontSize: 14 }}>
                                            Scanned By
                                        </InputLabel>
                                        <BootstrapInput
                                            type={"text"}
                                            sx={{ fontSize: 14 }}
                                            placeholder='Scanned By'
                                            id='bootstrap-input'
                                            value={
                                                Object.keys(selectedFaculty)
                                                    .length > 0
                                                    ? `${selectedFaculty.faculty_fname} ${selectedFaculty.faculty_lname}`
                                                    : ""
                                            }
                                            onClick={() => {
                                                setScannedByModal(true);
                                                setIsFilterApply(false);
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid>
                                    <FormControl
                                        variant='standard'
                                        style={{ minWidth: 230, maxWidth: "100%" }}
                                        fullWidth>
                                        <InputLabel
                                            shrink
                                            htmlFor='bootstrap-input'
                                            sx={{ fontSize: 14 }}>
                                            Verification Status
                                        </InputLabel>
                                        <Select
                                            labelId='demo-customized-select-label'
                                            id='demo-customized-select'
                                            sx={{ fontSize: 14 }}
                                            value={
                                                scannedResourcesFilters.verificationStatus
                                            }
                                            onChange={(e) => {
                                                setScannedResourcesFilters({
                                                    ...scannedResourcesFilters,
                                                    verificationStatus:
                                                        e.target.value,
                                                });
                                                setIsFilterApply(false);
                                            }}
                                            placeholder='Select status'
                                            input={<BootstrapInputForSelect />}>
                                            <MenuItem selected value=''>
                                                Select status
                                            </MenuItem>
                                            <MenuItem value='verified'>
                                                Verified
                                            </MenuItem>
                                            <MenuItem value='newly found'>
                                                Newly Found
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid>
                                    <FormControl variant='standard' fullWidth>
                                        <InputLabel
                                            shrink
                                            htmlFor='bootstrap-input'
                                            sx={{ fontSize: 14 }}>
                                            Accession Number
                                        </InputLabel>
                                        <BootstrapInput
                                            type={"text"}
                                            sx={{ fontSize: 14 }}
                                            placeholder='Enter Accession Number'
                                            id='bootstrap-input'
                                            value={
                                                scannedResourcesFilters.accessionsSeries
                                            }
                                            onChange={(e) => {
                                                setScannedResourcesFilters({
                                                    ...scannedResourcesFilters,
                                                    accessionsSeries:
                                                        e.target.value,
                                                });
                                                setIsFilterApply(false);
                                            }}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid
                                    direction={{
                                        lg: "row",
                                        md: "row",
                                        sm: "column",
                                        xs: "column",
                                    }}
                                    alignItems={"flex-end"}
                                    spacing={2}
                                    whiteSpace={2}
                                    pt={2}>
                                    <Grid container columnGap={2}>
                                        <Button
                                            variant={"contained"}
                                            mr={2}
                                            ml={2}
                                            sx={{ fontSize: 14 }}
                                            disableElevation
                                            onClick={() => applyFilters()}>
                                            Apply
                                        </Button>

                                        <Button
                                            variant={"outlined"}
                                            mr={2}
                                            ml={2}
                                            sx={{ fontSize: 14 }}
                                            disableElevation
                                            onClick={() => clearFilters()}>
                                            Clear
                                        </Button>

                                        <Button
                                            startIcon={
                                                <FontAwesomeIcon
                                                    icon={faFileExcel}
                                                />
                                            }
                                            sx={{ fontSize: 14 }}
                                            variant={"outlined"}
                                            disableElevation>
                                            <ReactHTMLTableToExcel
                                                id='test-table-xls-button'
                                                className='download-table-xls-button'
                                                style={{ all: "unset !important" }}
                                                table='table-to-xls'
                                                filename='tablexls'
                                                sheet='tablexls'
                                                buttonText='Export'
                                            />
                                        </Button>
                                        <Button
                                            startIcon={<Print />}
                                            variant={"outlined"}
                                            sx={{ fontSize: 14 }}
                                            disableElevation
                                            onClick={() => handlePrint()}>
                                            Print
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Paper>
                                <TableContainer sx={{ maxHeight: 360 }}>
                                    <Table
                                        sx={{ minWidth: 340 }}
                                        stickyHeader
                                        aria-label='sticky table'
                                        id='table-to-xls'
                                        ref={componentRef}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Sr. No.</TableCell>
                                                <TableCell align='right'>
                                                    Verification Status
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Accession Series
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Accession Number
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Title
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Resource Medium
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Author
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Invoice Number
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Resource Status
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Scanned By
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Scanned Date
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {scannedResourcesList.map(
                                                (item, index) => (
                                                    <TableRow
                                                        key={index.toString()}
                                                        sx={{
                                                            "&:last-child td, &:last-child th":
                                                                { border: 0 },
                                                        }}>
                                                        <TableCell>
                                                            {(pagination.pageIndex -
                                                                1) *
                                                                pagination.pagePerlimit +
                                                                index +
                                                                1}
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            {
                                                                item.verification_status
                                                            }
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            {item.accessionSeries !=
                                                                undefined &&
                                                                item.accessionSeries !=
                                                                null
                                                                ? item.accessionSeries
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            {item.accessionnumber !=
                                                                undefined &&
                                                                item.accessionnumber !=
                                                                null
                                                                ? item.accessionnumber
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell
                                                            align='right'
                                                            width={150}>
                                                            {item.title != null &&
                                                                item.title != undefined
                                                                ? item.title
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            {item.medium !=
                                                                undefined &&
                                                                item.medium != null
                                                                ? item.medium
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            {item.author != null &&
                                                                item.author != undefined
                                                                ? item.author
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            {item.invoiceNo !=
                                                                undefined &&
                                                                item.invoiceNo != null
                                                                ? item.invoiceNo
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell
                                                            align='right'
                                                            sx={{
                                                                textTransform:
                                                                    "capitalize",
                                                            }}>
                                                            {item.resourceStatus !=
                                                                undefined &&
                                                                item.resourceStatus !=
                                                                null
                                                                ? item.resourceStatus
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            {item.added_by_name !=
                                                                undefined &&
                                                                item.added_by_name !=
                                                                null
                                                                ? item.added_by_name
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            {item.added_datetime !=
                                                                undefined &&
                                                                item.added_datetime !=
                                                                null
                                                                ? item.added_datetime
                                                                : "-"}
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                {/* <TablePagination
                                    rowsPerPageOptions={[10, 25, 40, 100, 250]}
                                    colSpan={3}
                                    count={totalScannedResources}
                                    rowsPerPage={pagination.pagePerlimit}
                                    page={pagination.pageIndex - 1}
                                    SelectProps={{
                                        inputProps: {
                                            "aria-label": "rows per page",
                                        },
                                        native: true,
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                /> */}

                                <div className="printHide">
                                    <div className="mx-3" style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                        <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                            <span >Show</span>
                                            <select
                                                className="mx-2"
                                                value={pagination.pagePerlimit}
                                                onChange={(e) => handleChangePage(e)}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={40}>40</option>
                                                <option value={100}>100</option>
                                                <option value={250}>250</option>
                                            </select>
                                            <span>entries</span>
                                        </div>
                                        <div id="paginationContainer">
                                            <Pagination
                                                activePage={pagination.pageIndex}
                                                itemsCountPerPage={pagination.pagePerlimit}
                                                totalItemsCount={totalScannedResources}
                                                pageRangeDisplayed={3}
                                                onChange={(num) => handleChangeRowsPerPage(num)}
                                            />
                                        </div>
                                        <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {totalScannedResources} </p>
                                    </div>
                                </div>
                            </Paper>
                        </TabPanel>

                        <TabPanel value={value} index={1}>
                            <Paper>
                                <TableContainer sx={{ maxHeight: 360 }}>
                                    <Table
                                        sx={{ minWidth: 360, fontSize: "14" }}
                                        stickyHeader
                                        aria-label='sticky table'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Sr. No.</TableCell>
                                                <TableCell align='right'>
                                                    Issued To
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Title
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Author
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Accession Series
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Accession Number
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Role
                                                </TableCell>
                                                <TableCell align='right'>
                                                    User ID
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Issued Policy Name
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Location
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Issued Date
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Due Date
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Renewal Date
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Applicable Fine
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Collected Fine
                                                </TableCell>
                                                <TableCell align='right'>
                                                    Issued by
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {IssuedResourcesSortedIdArray.map(
                                                (resourceId, index) => {
                                                    let item =
                                                        IssuedResources[resourceId];
                                                    if (item != undefined) {
                                                        return (
                                                            <TableRow
                                                                key={index.toString()}
                                                                sx={{
                                                                    "&:last-child td, &:last-child th":
                                                                        { border: 0 },
                                                                }}>
                                                                <TableCell>
                                                                    {(IssuedResourcePagination.pageIndex -
                                                                        1) *
                                                                        IssuedResourcePagination.limit +
                                                                        index +
                                                                        1}
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {item.user_name}
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {item.author}
                                                                </TableCell>
                                                                <TableCell
                                                                    align='right'
                                                                    sx={{
                                                                        whiteSpace:
                                                                            "normal",
                                                                        wordWrap:
                                                                            "break-word",
                                                                    }}>
                                                                    {item.title}
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {
                                                                        item.accession_series
                                                                    }
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {
                                                                        item.accessionnumber
                                                                    }
                                                                </TableCell>
                                                                <TableCell
                                                                    align='right'
                                                                    sx={{
                                                                        textTransform:
                                                                            "capitalize",
                                                                    }}>
                                                                    {item.user_role}
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {item.user_id}
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {
                                                                        item.policyName
                                                                    }
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {item.location}
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {
                                                                        item.issued_date
                                                                    }
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {item.dueDate}
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {
                                                                        item.renewal_date
                                                                    }
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {
                                                                        item.fine_amount
                                                                    }
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {
                                                                        item.collected_fine_amount
                                                                    }
                                                                </TableCell>
                                                                <TableCell align='right'>
                                                                    {item.issuedBy}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    }
                                                }
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                {/* <TablePagination
                                    rowsPerPageOptions={[10, 25, 40, 100, 250]}
                                    colSpan={3}
                                    count={totalIssuedResourceCount}
                                    rowsPerPage={IssuedResourcePagination.limit}
                                    page={IssuedResourcePagination.pageIndex - 1}
                                    SelectProps={{
                                        inputProps: {
                                            "aria-label": "rows per page",
                                        },
                                        native: true,
                                    }}
                                    onPageChange={handleChangeForIssuedResourcePage}
                                    onRowsPerPageChange={
                                        handleChangeForIssuedResourceRowsPerPage
                                    }
                                /> */}

                                <div className="printHide">
                                    <div className="mx-3" style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                        <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                            <span >Show</span>
                                            <select
                                                className="mx-2"
                                                value={IssuedResourcePagination.limit}
                                                onChange={(e) => handleChangeForIssuedResourcePage(e)}
                                            >
                                                <option value={10}>10</option>
                                                <option value={25}>25</option>
                                                <option value={40}>40</option>
                                                <option value={100}>100</option>
                                                <option value={250}>250</option>
                                            </select>
                                            <span>entries</span>
                                        </div>
                                        <div id="paginationContainer">
                                            <Pagination
                                                activePage={IssuedResourcePagination.pageIndex}
                                                itemsCountPerPage={IssuedResourcePagination.limit}
                                                totalItemsCount={totalIssuedResourceCount}
                                                pageRangeDisplayed={3}
                                                onChange={(num) => handleChangeForIssuedResourceRowsPerPage(num)}
                                            />
                                        </div>
                                        <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {totalIssuedResourceCount} </p>
                                    </div>
                                </div>

                            </Paper>
                        </TabPanel>

                        <TabPanel value={value} index={2}>
                            {Object.keys(markAsCompletedData).length > 0 ? (
                                <Paper>
                                    <TableContainer sx={{ maxHeight: 440 }}>
                                        <Table
                                            sx={{ minWidth: 360 }}
                                            stickyHeader
                                            aria-label='sticky table'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Sr. No.</TableCell>

                                                    <TableCell align='right'>
                                                        Accession Series
                                                    </TableCell>
                                                    <TableCell align='right'>
                                                        Accession Number
                                                    </TableCell>
                                                    <TableCell align='right'>
                                                        Title
                                                    </TableCell>
                                                    <TableCell align='right'>
                                                        Resource Medium
                                                    </TableCell>
                                                    <TableCell align='right'>
                                                        Author
                                                    </TableCell>
                                                    <TableCell align='right'>
                                                        Invoice Number
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {missingResourceList.map(
                                                    (item, index) => {
                                                        if (item != undefined) {
                                                            return (
                                                                <TableRow
                                                                    key={index.toString()}
                                                                    sx={{
                                                                        "&:last-child td, &:last-child th":
                                                                        {
                                                                            border: 0,
                                                                        },
                                                                    }}>
                                                                    <TableCell>
                                                                        {(missingResourcePagination.pageIndex -
                                                                            1) *
                                                                            missingResourcePagination.limit +
                                                                            index +
                                                                            1}
                                                                    </TableCell>

                                                                    <TableCell align='right'>
                                                                        {
                                                                            item.accession_series
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align='right'>
                                                                        {
                                                                            item.accessionnumber
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell
                                                                        align='right'
                                                                        sx={{
                                                                            whiteSpace:
                                                                                "normal",
                                                                            wordWrap:
                                                                                "break-word",
                                                                        }}>
                                                                        {item.title}
                                                                    </TableCell>
                                                                    <TableCell align='right'>
                                                                        {
                                                                            item.medium
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell
                                                                        align='right'
                                                                        sx={{
                                                                            whiteSpace:
                                                                                "normal",
                                                                            wordWrap:
                                                                                "break-word",
                                                                        }}>
                                                                        {
                                                                            item.author
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align='right'>
                                                                        {
                                                                            item.invoiceno
                                                                        }
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        }
                                                    }
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    {/* <TablePagination
                                        rowsPerPageOptions={[10, 25, 40, 100, 250]}
                                        colSpan={3}
                                        elevation={0}
                                        count={totalMissingCount}
                                        rowsPerPage={
                                            missingResourcePagination.limit
                                        }
                                        page={
                                            missingResourcePagination.pageIndex - 1
                                        }
                                        SelectProps={{
                                            inputProps: {
                                                "aria-label": "rows per page",
                                            },
                                            native: true,
                                        }}
                                        onPageChange={
                                            handleChangeForMissingResourcePage
                                        }
                                        onRowsPerPageChange={
                                            handleChangeForMissingResourceRowsPerPage
                                        }
                                    /> */}

                                    <div className="printHide">
                                        <div className="mx-3" style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                            <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                                <span >Show</span>
                                                <select
                                                    className="mx-2"
                                                    value={missingResourcePagination.limit}
                                                    onChange={(e) => handleChangeForMissingResourcePage(e)}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={40}>40</option>
                                                    <option value={100}>100</option>
                                                    <option value={250}>250</option>
                                                </select>
                                                <span>entries</span>
                                            </div>
                                            <div id="paginationContainer">
                                                <Pagination
                                                    activePage={missingResourcePagination.pageIndex}
                                                    itemsCountPerPage={missingResourcePagination.limit}
                                                    totalItemsCount={totalMissingCount}
                                                    pageRangeDisplayed={3}
                                                    onChange={(num) => handleChangeForMissingResourceRowsPerPage(num)}
                                                />
                                            </div>
                                            <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {totalMissingCount} </p>
                                        </div>
                                    </div>
                                </Paper>
                            ) : (
                                <Card
                                    sx={{
                                        display: "flex",
                                        "justify-content": "center",
                                        "align-items": "center",
                                        background: "#FFEFDE",
                                        mt: 2,
                                    }}
                                    elevation={0}>
                                    <CardContent>
                                        <Typography>
                                            You can only see the missing/ Yet to
                                            Scan Resources after completing the
                                            stock verification process. In order to
                                            do that, please click on the 'Mark as
                                            completed button'.
                                        </Typography>
                                    </CardContent>
                                </Card>
                            )}
                        </TabPanel>
                    </Grid>
                </Grid>

                <Dialog
                    open={scannedByModal}
                    onClose={() => {
                        setScannedByModal(false);
                    }}>
                    <DialogTitle>Scanned By</DialogTitle>
                    <DialogContent>
                        <Paper elevation={0}>
                            <BootstrapInput
                                type={"text"}
                                sx={{ fontSize: 14 }}
                                fullWidth
                                placeholder='Enter Faculty Name & Press Enter Key'
                                id='bootstrap-input'
                                value={searchByScannnedName}
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        apiCallToGetFacultyList();
                                    }
                                }}
                                onChange={(e) => {
                                    setSearchByScannedName(e.target.value);
                                }}
                            />
                            <TableContainer sx={{ maxHeight: 440 }}>
                                <Table
                                    sx={{ minWidth: 650 }}
                                    stickyHeader
                                    aria-label='sticky table'
                                    id='table-to-xls'
                                    ref={componentRef}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>Sr. No.</TableCell>
                                            <TableCell align='right'>
                                                Name
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {facultyList.map((item, index) => (
                                            <TableRow
                                                key={index.toString()}
                                                sx={{
                                                    "&:last-child td, &:last-child th":
                                                        { border: 0 },
                                                }}>
                                                <TableCell>
                                                    <Radio
                                                        checked={
                                                            selectedFaculty.faculty_id ===
                                                            item.faculty_id
                                                        }
                                                        onChange={() => {
                                                            setSelectedFaculty(
                                                                item
                                                            );
                                                        }}
                                                        value={item.faculty_id}
                                                        name='radio-buttons'
                                                        inputProps={{
                                                            "aria-label": "A",
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    {(paginationScannedBy.pageIndex -
                                                        1) *
                                                        paginationScannedBy.limit +
                                                        index +
                                                        1}
                                                </TableCell>
                                                <TableCell align='right'>
                                                    {item.faculty_fname}{" "}
                                                    {item.faculty_lname}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <TablePagination
                                rowsPerPageOptions={[10, 25, 40, 100, 250]}
                                colSpan={3}
                                elevation={0}
                                count={totalScannedBy}
                                rowsPerPage={paginationScannedBy.limit}
                                page={paginationScannedBy.pageIndex - 1}
                                SelectProps={{
                                    inputProps: {
                                        "aria-label": "rows per page",
                                    },
                                    native: true,
                                }}
                                onPageChange={handleChangeForHandleScannedByPage}
                                onRowsPerPageChange={
                                    handleChangeForScannedByRowsPerPage
                                }
                            />
                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setSelectedFaculty({});
                                setScannedByModal(false);
                                setSearchByScannedName("");
                            }}>
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                setScannedResourcesFilters({
                                    ...scannedResourcesFilters,
                                    scanned_by: selectedFaculty.faculty_id,
                                });
                                setScannedByModal(false);
                            }}>
                            Select
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={confirmationModal}
                    onClose={() => {
                        setConfirmationModal(false);
                    }}>
                    <Box
                        sx={{
                            display: "flex",
                            "justify-content": "space-between",
                            " align-items": "center",
                        }}>
                        <DialogTitle>
                            <Warning color={"warning"} />
                            Are you sure ?
                        </DialogTitle>

                        <IconButton onClick={() => setConfirmationModal(false)}>
                            <Close />
                        </IconButton>
                    </Box>
                    <DialogContent>
                        <DialogContentText>
                            You are about to complete the stock verification of “
                            {
                                props.selectedStockVerification
                                    .stock_verification_name
                            }
                            ”, Be sure that all your resources are verified before
                            confirming it.
                        </DialogContentText>
                        <DialogContentText mt={2}>
                            After you click on “Mark as Completed”, you can get a
                            list of all the missing/yet to scan resources list.
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            variant='outlined'
                            onClick={() => setConfirmationModal(false)}>
                            Cancel
                        </Button>
                        <Button
                            variant='contained'
                            onClick={() => apiCallToMarkAsCompleted()}>
                            Mark As Completed
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
}

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
        marginTop: theme.spacing(2),
    },
    "& .MuiInputBase-input": {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
        border: "1px solid #ced4da",
        fontSize: 16,
        padding: "10px 12px",
        transition: theme.transitions.create([
            "border-color",
            "background-color",
            "box-shadow",
        ]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            boxShadow: `${alpha(
                theme.palette.primary.main,
                0.25
            )} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}));

const BootstrapInputForSelect = styled(InputBase)(({ theme }) => ({
    "label + &": {
        marginTop: theme.spacing(2),
    },

    "& .MuiInputBase-input": {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #ced4da",
        fontSize: 16,
        padding: "10px 26px 10px 12px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            borderRadius: 4,
            borderColor: "#80bdff",
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
        },
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
